import React from 'react';
import MatnrIntegrationStatusFilters from './components/MatnrIntegrationStatusFilter';
import MatnrIntegrationStatusTable from './components/MatnrIntegrationStatusTable';
import useMatnrIntegrationStatusData from './hooks/useMatnrIntegrationStatusReport';
import { useLanguage } from '../../../contexts/LanguageContext';

const MatnrIntegrationStatusPage = () => {
    const { th } = useLanguage();
    const {
        rows,
        totalRecords,
        loading,
        filters,
        lazyParams,
        onPage,
        onSort,
        handleApplyFilters,
        handleResetFilters,
    } = useMatnrIntegrationStatusData();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">
                    {th('matnrIntegrationStatus.title') || 'YP Görünürlüğü'}
                </h1>
            </div>

            <div className="mb-2">
                <MatnrIntegrationStatusFilters
                    filters={filters}
                    onApplyFilters={handleApplyFilters}
                    onReset={handleResetFilters}
                />
            </div>

            <MatnrIntegrationStatusTable
                items={rows}
                totalRecords={totalRecords}
                loading={loading}
                lazyParams={lazyParams}
                onPage={onPage}
                onSort={onSort}
            />
        </div>
    );
};

export default MatnrIntegrationStatusPage;